<template>
    <jet-dialog-modal :show="true" @close="$emit('close')">
        <template #title>
            Confirm Pause
        </template>

        <template #content>
            <div class="mb-4 mt-4">
                Your account pause will take effect at the start of your next billing cycle on <strong>{{ formattedEndDate }}</strong>.<br/><br />
                Your phone number and registration status will remain active and approved. You will not be able to send messages while your account is paused. Activate your account again at anytime by subscribing to a plan.
            </div>
        </template>

        <template #footer>

            <jet-button text @click.native="$emit('close')" class="mr-4">
                Nevermind
            </jet-button>

            <jet-button secondary @click.native="$emit('pause')">
                PAUSE ACCOUNT
            </jet-button>
        </template>
    </jet-dialog-modal>

</template>


<script>
export default {
    name: 'PauseAccountConfirmation',
    emits: ['close', 'pause'],
    components: {
    },
    computed: {
        formattedEndDate() {
            if (!this.$page.props.current_plan_end_date) {
                return 'N/A';
            }
            return moment.unix(this.$page.props.current_plan_end_date).format('MMMM D, YYYY');
        }
    }

}
</script>